import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthGate } from './SignIn';
import { Home } from './Home';
import { NewVessel } from './NewVessel';
import './styles.css';
import './site.css';

/* a request typed on Home travels in memory to the studio chat box (never in the address bar) */
let pendingAsk: string | undefined; const takeAsk = () => { const a = pendingAsk; pendingAsk = undefined; return a; };

/** "/" = signed-in home · "/studio?project=…" = the studio. Visitors who are not signed in see the public landing page (AuthGate). */
function Shell(p: { me: any; signOut: () => void }) {
  const read = () => { const q = new URLSearchParams(location.search); return { draft: (location.pathname.match(/^\/new\/([a-f0-9-]{36})$/) ?? [])[1], studio: location.pathname.startsWith('/studio'), project: q.get('project') ?? '', view: q.get('view') ?? undefined }; };
  const [r, setR] = useState(read);
  useEffect(() => { const f = () => setR(read()); addEventListener('popstate', f); return () => removeEventListener('popstate', f); }, []);
  const nav = (url: string) => { history.pushState(null, '', url); setR(read()); window.scrollTo(0, 0); };
  const openP = (id: string, o?: { ask?: string; view?: string }) => { pendingAsk = o?.ask; nav(`/studio?project=${encodeURIComponent(id)}${o?.view ? `&view=${encodeURIComponent(o.view)}` : ''}`); };
  if (r.draft) return <NewVessel id={r.draft} open={openP} home={() => nav('/')} />;
  if (r.studio) return <App key={r.project} me={p.me} signOut={p.signOut} initialProject={r.project || undefined} initialAsk={takeAsk()} initialView={r.view} goHome={() => nav('/')} />;
  return <Home me={p.me} signOut={p.signOut} open={openP} newDraft={(id, refs) => nav(`/new/${id}${refs ? '#refs' : ''}`)} />;
}

createRoot(document.getElementById('root')!).render(<AuthGate>{(me, signOut) => <Shell me={me} signOut={signOut} />}</AuthGate>);
